import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import type { PluginListenerHandle } from '@capacitor/core';
import { BundleInfo } from '@capgo/capacitor-updater';
import { downloadLatestBundle, setBundle } from 'src/utils/capacitor/app-updater';

export const useSetUpdateCapgoBundleOnBgListener = () => {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    let listener: PluginListenerHandle | null;

    const registerListener = async () => {
      let bundle: BundleInfo | null = null;

      listener = await App.addListener('appStateChange', async (state: any) => {
        try {
          if (state.isActive) {
            bundle = await downloadLatestBundle();
          }

          if (!state.isActive && bundle) {
            await setBundle(bundle.id);
          }
        } catch (e) {
          // It's fine
        }
      });
    };

    void registerListener();

    return () => void listener?.remove();
  }, []);
};
